<div [style.height.px]="height" class="progress">
    <div [attr.aria-valuenow]="percentValue" [style.background-color]="color" [style.width]="percentValue+'%'"
         aria-valuemax="100"
         aria-valuemin="0"
         class="progress-bar" role="progressbar">
        {{percentValue}}%
    </div>
</div>